import { useEffect, useState } from "react";

const useVerifyUnique = (
  documents,
  field,
  checkValue,
  oldValue,
  baseData,
  baseDataKey,
) => {
  const [exists, setExists] = useState(false);
  useEffect(() => {
    let values = [];
    if (baseData) {
      if (baseData[baseDataKey]) {
        baseData[baseDataKey].forEach((doc) => {
          if (doc[field] !== oldValue) {
            values.push(doc[field]);
          }
        });
      }
    } else if (documents) {
      documents.forEach((doc) => {
        if (doc[field] !== oldValue) {
          values.push(doc[field]);
        }
      });
    }
    setExists(values.includes(checkValue));
  }, [documents, checkValue, field, oldValue, baseData, baseDataKey]);
  return { exists };
};

export { useVerifyUnique };
